import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Layout from "./layout";
import LayoutDashboard from "./layout/layout";
import Table from "components/table/table";
import { useCallback, useEffect, useState } from "react";
import PerfilService from "../../services/PerfilService";
import { useNavigate, useParams } from "react-router-dom";
import AttachmentsPosts from "./AttachmentsPosts";
import FormFieldInput from "components/campos/input";
import FormFieldTextArea from "components/campos/textarea";
import FormFieldFileInput from "components/campos/file";
import FormFieldSelect from "components/campos/select";
import canaisService from "../../services/CanaisService";
import EventsService from "../../services/EventService";
import { toast } from "react-toastify";
import FormFieldSwith from "components/campos/FormFieldSwith";
import * as Yup from 'yup';
import { set } from "lodash";
import AddressFields from "./AddressFields";
import Event from "services/EventService";

const EventsCreateOrEdit = () => {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [functionPage, setFunctionPage] = useState('create');
  const [user, setUser] = useState({} as any);
  const [loading, setLoading] = useState(false);
  
  const [subCategoriesBase, setSubCategoriesBase]       = useState([]);
  const [categoriesOptions, setCategoriesOptions]       = useState([]);
  const [subCategoriesOptions, setSubCategoriesOptions] = useState([]);
  const [groupCitiesOptions, setGroupCitiesOptions]     = useState([]);

  const [showAddressFields, setShowAddressFields] = useState(true); 

  const [componentKey, setComponentKey] = useState(0);

  const [dados, setDados] = useState(null);
  const [anexos, setAnexos] = useState([]);

  // pegando o parametro da url
  const { id } = useParams();
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    banner: Yup.string().nullable(),
    bannerPreview: Yup.string().nullable(),
    logo: Yup.string().nullable(),
    logoPreview: Yup.string().nullable(),
    event: Yup.object().shape({
      category_id: Yup.string().required('Categoria é obrigatória'),
      subcategory_id: Yup.string().required('Subcategoria é obrigatória'),
      name: Yup.string().required('Nome é obrigatório'),
      description: Yup.string().required('Descrição é obrigatória'),
      initial_date: Yup.string().required('Data inicial é obrigatória'),
      final_date: Yup.string().required('Data final é obrigatória'),
      hasnt_address: Yup.boolean().nullable(),
    }),
    // address: Yup.object().when('event.hasnt_address', {
    //   is: false, // Valida o endereço apenas se hasnt_address for false
    //   then: Yup.object().shape({
    //     country: Yup.string().required('País é obrigatório'),
    //     state: Yup.string().required('Estado é obrigatório'),
    //     city: Yup.string().required('Cidade é obrigatória'),
    //     postal_code: Yup.string().required('CEP é obrigatório'),
    //     address: Yup.string().required('Endereço é obrigatório'),
    //     number: Yup.string().required('Número é obrigatório'),
    //     district: Yup.string().required('Bairro é obrigatório'),
    //     complement: Yup.string().nullable(),
    //   }),
    //   otherwise: Yup.object().strip(), // Remove o objeto address se hasnt_address for true
    // }),
    post: Yup.object().shape({
      group_city_id: Yup.string().required('Grupo de cidades é obrigatório'),
    }),
  });

  const setNestedValue = (object: any, path: string, value: any) => {
    const keys = path.split(".");
    const lastKey: any = keys.pop();
    const lastObj = keys.reduce((obj, key) => {
      if (!obj[key]) obj[key] = {};
      return obj[key];
    }, object);
    lastObj[lastKey] = value;
  };
  
  const useForm = (initialState: any) => {
    const [formData, setFormData] = useState(initialState);
  
    const handleChange = (fieldName: string, value: any) => {
      setFormData((prevData: any) => {
        const newData = { ...prevData };
        setNestedValue(newData, fieldName, value);
    
        // Atualiza a visibilidade dos campos de endereço
        if (fieldName === "event.hasnt_address") {
          setShowAddressFields(!value); // Inverte o valor (true/false)
        }
    
        return newData;
      });
    };
  
    return { formData, handleChange };
  };

  const { formData, handleChange } = useForm({
    banner: "",
    bannerPreview: "",
    logo: "",
    logoPreview: "",
    event: {
      category_id: "",
      subcategory_id: "",
      name: "",
      description: "",
      initial_date: "",
      final_date: "",
      hasnt_address: false, // Certifique-se de que esse campo existe e é booleano
    },
    address: {
      country: "",
      state: "",
      city: "",
      postal_code: "",
      address: "",
      number: "",
      district: "",
      complement: "",
    },
    post: {
      group_city_id: "",
    },
  });

  useEffect(() => {
    if (id) {
      setFunctionPage('edit');
    }
  }, [id]);

  useEffect(() => {
    if (dados) {

      handleChange("event.category_id", dados?.category_id);
      setSubCategoriesOptions(subCategoriesBase.filter((item: any) => item.category_id == dados?.category_id));      

      handleChange("event.category_id", dados?.category_id);
      handleChange("event.subcategory_id", dados?.subcategory_id);
      handleChange("event.name", dados?.name);
      handleChange("event.description", dados?.description);
      handleChange("event.initial_date", dados?.initial_date);
      handleChange("event.final_date", dados?.final_date);
      handleChange("event.hasnt_address", dados?.hasnt_address);
      handleChange("bannerPreview", dados?.banner_path);
      handleChange("logoPreview", dados?.logo_path);
  
      if (dados?.address) {
        handleChange("address.country", dados?.address?.country);
        handleChange("address.state", dados?.address?.state);
        handleChange("address.city", dados?.address?.city);
        handleChange("address.postal_code", dados?.address?.postal_code);
        handleChange("address.address", dados?.address?.address);
        handleChange("address.number", dados?.address?.number);
        handleChange("address.district", dados?.address?.district);
        handleChange("address.complement", dados?.address?.complement);
      }
  
      handleChange("post.group_city_id", dados?.post?.group_city_id);

      setAnexos(dados.attachments);

      // 🔹 Atualiza a key para forçar re-renderização
      setComponentKey((prevKey) => prevKey + 1);
    }
  }, [dados]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getUser();
      await getCanais(2);
      if (id) {
        await getEvent(id);
      }
    }
    fetchData();
  }, []);  

  const getEvent = async (eventId : any) => {
    await Event.getEventDetail(eventId)
      .then((response: any) => {
        setDados(response.data);

        if(response.data.address == null){
          handleChange("event.hasnt_address", true);
          setShowAddressFields(false);
        }
      })
      .catch((error: any) => {
        console.error(error);
      });
  }

  const getUser = async () => {
    await PerfilService.getUser()
      .then((response: any) => {
        setUser(response.data.user);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
       //setLoading(false); // end loading
      });
  };

  const getCanais = async (idTipo: any) => {
    await canaisService
      .getCanais(idTipo, "")
      .then((response: any) => {

        const categories = response.categories.map((item: any) => {
          return { value: item.id, label: item.name };
        });

        const subcategories = response.subcategories.map((item: any) => {
          return { value: item.id, label: item.name, category_id: item.category_id };
        });

        const groupCities = response.group_cities.map((item: any) => {
          return { value: item.id, label: item.name };
        });

        setCategoriesOptions(categories);
        setGroupCitiesOptions(groupCities);
        setSubCategoriesOptions(subcategories);

        setSubCategoriesBase(subcategories);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // end loading
      });
  };

  const submit = async () => {

    try {
      // Valida o formulário
      await validationSchema.validate(formData, { abortEarly: false });

      if (functionPage == 'create') {
        // Valida se o banner foi enviado
        if (!formData.banner) {
          toast.error('Banner é obrigatório');
          setErrors({ ...errors, banner: 'Banner é obrigatório' });
          return;
        }

        // Valida se o logo foi enviado
        if (!formData.logo) {
          toast.error('Logo é obrigatório');
          setErrors({ ...errors, logo: 'Logo é obrigatório' });
          return;
        }
      }

      // Verificando manualmente se os campos de endereço são obrigatórios - se hasnt_address for false pais e estado somente
      if (!formData.event.hasnt_address) {
        if (!formData.address.country) {
          toast.error('País é obrigatório');
          setErrors({ ...errors, 'address.country': 'País é obrigatório caso declare endereço' });
          return;
        }
        if (!formData.address.state) {
          toast.error('Estado é obrigatório');
          setErrors({ ...errors, 'address.state': 'Estado é obrigatório caso declare endereço' });
          return;
        }
      }

      // Se a validação passar, prossegue com o envio
      let newDados: any = {
        event: {
          category_id: formData.event.category_id,
          subcategory_id: formData.event.subcategory_id,
          name: formData.event.name,
          description: formData.event.description,
          initial_date: formData.event.initial_date,
          final_date: formData.event.final_date,
          hasnt_address: formData.event.hasnt_address,
          banner: formData.banner,
          logo: formData.logo,
        },
        post: {
          group_city_id: formData.post.group_city_id,
        },
      };
  
      if (!formData.event.hasnt_address) {
        newDados.address = {
          country: formData.address.country,
          state: formData.address.state,
          city: formData.address.city,
          postal_code: formData.address.postal_code,
          address: formData.address.address,
          number: formData.address.number,
          district: formData.address.district,
          complement: formData.address.complement,
        };
      }
  
      newDados = verificarBannerDica(newDados);
      newDados = verificarLogoDica(newDados);
    
      let response: any;
      if (id) {
        response = await EventsService.update(id, newDados);
      } else {
        response = await EventsService.post(newDados);
      }
  
      toast.success('Dica salva com sucesso!');
      navigate('/meus-eventos');

    } catch (error : any) {

      if (error instanceof Yup.ValidationError) {
        // Exibe os erros de validação
        const errors = error.inner.reduce((acc, curr) => {
          acc[curr.path] = curr.message;
          return acc;
        }, {} as Record<string, string>);
  
        console.log('errors setando', errors);
        setErrors(errors);

        // Exibe o primeiro erro encontrado
        const firstError = Object.values(errors)[0];
        toast.error(firstError);

      } else {
       //informa o primeiro erro retornado considerando que o backend é em laravel com um arquivo de request
       toast.error(error.response.data.errors[Object.keys(error.response.data.errors)[0]][0]);
      }
    }
  };

  const verificarBannerDica = (obj: any) => {
    if (obj.event.banner == "") {
      obj.event.banner_path = dados.banner_path;
    }

    return obj;
  };

  const verificarLogoDica = (obj: any) => {
    if (obj.event.banner == "") {
      obj.event.banner_path = dados.banner_path;
    }

    return obj;
  };

  const handleCategoryChange = useCallback((categoryId: any) => {
    if (categoryId) {
      setSubCategoriesOptions(subCategoriesBase.filter((item: any) => item.category_id == categoryId)); 
    } else {
      setSubCategoriesOptions([]);
    }
    handleChange("event.subcategory_id", "");
  }, [subCategoriesBase]);

  return (
    <Layout user={user}>
      <LayoutDashboard>
      <>
        <div className="flex-end">
          <ButtonPrimary
            className="md:col-span-2"
            type="button"
            onClick={() => navigate('/meus-eventos')}
          >
            Voltar
          </ButtonPrimary>
        </div>
        <br />

        {
          loading ? (
            <div>
              <div className="spinner border-primary-600 my-20"></div>
            </div>
          ) : (
            <div className="rounded-xl md:border md:border-neutral-100 dark:border-neutral-800 md:p-6">
              {dados != null && <AttachmentsPosts tipoTela={4} dados={dados} anexos={anexos} setAnexos={setAnexos} />}
    
              <form className="grid md:grid-cols-2 gap-6" action="#" method="post">

                <FormFieldSelect
                  key={'category_id_' + componentKey}
                  label={'Categoria'}
                  fieldName={'event.category_id'}
                  options={categoriesOptions}
                  formData={formData}
                  handleChange={handleChange}
                  action={handleCategoryChange}
                  error={errors['event.category_id']}
                />
    
                <FormFieldSelect
                  key={'subcategory_id'}
                  label={'Subcategoria'}
                  fieldName={'event.subcategory_id'}
                  options={subCategoriesOptions}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['event.subcategory_id']}
                />
    
                <FormFieldInput
                  key={"name"}
                  label={"Nome"}
                  fieldName={"event.name"}
                  type={"text"}
                  extraProps={{ mdColSpan: 2 }}
                  formData={formData}
                  handleChange={handleChange}
                  classe={"md:col-span-2"}
                  error={errors['event.name']}
                />
    
                <FormFieldTextArea
                  key={"description"}
                  label={"Descrição"}
                  fieldName={"event.description"}
                  extraProps={{ rows: 8, mdColSpan: 2 }}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['event.description']}
                />
    
                <FormFieldSelect
                  key={"group_city_id"}
                  label={"Grupo de Cidades"}
                  fieldName={"post.group_city_id"}
                  options={groupCitiesOptions}
                  formData={formData}
                  handleChange={handleChange}
                  classe={"md:col-span-2"}
                  error={errors['post.group_city_id']}
                />
    
                <FormFieldInput
                  key={"initial_date"}
                  label={"Data Inicial"}
                  fieldName={"event.initial_date"}
                  type={"date"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['event.initial_date']}
                />                
                
                <FormFieldInput
                  key={"final_date"}
                  label={"Data Final"}
                  fieldName={"event.final_date"}
                  type={"date"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['event.final_date']}
                />
    
                <hr className="mt-5 col-span-1 md:col-span-2" />
    
                <FormFieldSwith 
                  label={"Essa dica não possui endereço ?"} 
                  fieldName={"event.hasnt_address"} 
                  formData={formData} 
                  handleChange={handleChange} 
                  extraProps={{ mdColSpan: 2 }} 
                  classe={"md:col-span-2"}
                  error={errors['event.hasnt_address']}
                />
                
                <div
                  className={`col-span-1 md:col-span-2 transition-all duration-300 ease-in-out ${
                    showAddressFields
                      ? "opacity-100 max-h-[1000px] overflow-visible"
                      : "opacity-0 max-h-0 overflow-hidden"
                  }`}
                >
                  <AddressFields formData={formData} handleChange={handleChange} errors={errors} />
                </div>
    
                <FormFieldFileInput
                  key={"banner"}
                  label={"Banner"}
                  fieldName={"banner"}
                  formData={formData}
                  handleChange={handleChange}
                  classNameImagem={""}
                  tipo={4}
                  error={errors['banner']}
                />

                <FormFieldFileInput
                  key={"logo"}
                  label={"Logo"}
                  fieldName={"logo"}
                  formData={formData}
                  handleChange={handleChange}
                  classNameImagem={""}
                  tipo={4}
                  error={errors['logo']}
                />
    
                <ButtonPrimary
                  className="md:col-span-2"
                  type="button"
                  onClick={submit}
                >
                  {functionPage == 'create' ? 'Salvar' : 'Editar'}
                </ButtonPrimary>
              </form>
            </div>
          )
        }

      </>
      </LayoutDashboard>
    </Layout>
  );
};

export default EventsCreateOrEdit;
